import { isCollabEditingEnabled } from "../collab/collab-feature-gate";
import { connectDesignerEventStream, IDesignerStreamHandle } from "./designer-events-stream";
import { DESIGNER_LIVE_CLIENT_ID } from "./designer-live-client-id";
import { IDesignerLiveEvent, IDesignerPresence } from "./designer-live-types";
import { DesignerPresenceReporter } from "./designer-presence";
import { DesignerSyncService } from "./designer-sync-service";

/**
 * Designer-live bootstrap (Faz 5): one stream per tab, started when a project opens and
 * restarted on project switch. Routes "change" frames into DesignerSyncService (hybrid
 * refresh + stale-write bookkeeping) and "presence.roster" frames into the collab
 * provider's project roster (the avatar stack).
 */

interface ICollabRosterSink {
  collabProvider: { setDesignerRoster: (roster: IDesignerPresence[]) => void };
}

let streamHandle: IDesignerStreamHandle | null = null;
let activeProjectId: string | null = null;

export function startDesignerLive(projectId: string): void {
  if (!isCollabEditingEnabled()) return;
  if (!projectId) return;
  if (activeProjectId === projectId && streamHandle) return;
  stopDesignerLive();

  activeProjectId = projectId;
  DesignerPresenceReporter.start(DESIGNER_LIVE_CLIENT_ID);
  streamHandle = connectDesignerEventStream(DESIGNER_LIVE_CLIENT_ID, (liveEvent: IDesignerLiveEvent) => {
    if (!activeProjectId) return;
    if (liveEvent.type === "presence.roster") {
      const w = window as unknown as { getSdInstance?: () => ICollabRosterSink };
      w.getSdInstance?.()?.collabProvider.setDesignerRoster(liveEvent.roster ?? []);
      return;
    }
    DesignerSyncService.applyRemote(liveEvent, activeProjectId);
  });
}

export function stopDesignerLive(): void {
  if (streamHandle) {
    streamHandle.stop();
    streamHandle = null;
  }
  DesignerPresenceReporter.stop();
  DesignerSyncService.reset();
  activeProjectId = null;
}

/** Deferred (busy-tool) reloads apply the moment the tool goes idle. */
export function notifyDesignerLiveToolIdle(): void {
  if (activeProjectId) DesignerSyncService.onToolIdle(activeProjectId);
}
